import { render, staticRenderFns } from "./AudienceListItem.vue?vue&type=template&id=32349fe2&scoped=true"
import script from "./AudienceListItem.vue?vue&type=script&lang=ts"
export * from "./AudienceListItem.vue?vue&type=script&lang=ts"
import style0 from "./AudienceListItem.vue?vue&type=style&index=0&id=32349fe2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32349fe2",
  null
  
)

export default component.exports